import { App } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { BodyOf, Result } from "@/shared/api";
import { apiPost, errorMessage, qk } from "@/shared/api";
import type { paths } from "@/api/types";

export type ManualBody = BodyOf<paths["/api/v1/admin/accruals/manual"]["post"]>;
export type ManualResult = Result<paths["/api/v1/admin/accruals/manual"]["post"]>;

export function useManualAccrual(userId: number | null) {
  const queryClient = useQueryClient();
  const { message } = App.useApp();

  return useMutation({
    mutationFn: (body: ManualBody) => apiPost("/api/v1/admin/accruals/manual", { body }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qk.accrualHistory(userId) });
      void queryClient.invalidateQueries({ queryKey: ["users"] });
      void queryClient.invalidateQueries({ queryKey: qk.dashboard() });
      void queryClient.invalidateQueries({ queryKey: ["audit"] });
    },
    onError: (error) => {
      void message.error(errorMessage(error));
    },
  });
}
